import { Attribute } from "./attribute";

export class AttributeGroup {
    constructor(
        public id: number,
        public name: string,
        public attributes: Array<Attribute> = []
    ) { }
}